<!-- Chat panel - always present but positioned off-screen when closed -->
<div class="chat-panel-container">
  <!-- CHAT HEADER -->
  <div class="chat-header">
    @if (state === ChatState.Ready) {
      <button class="btn btn-icon-only" (click)="newChat()" tooltip="Start new chat">
        <svg-icon key="refresh" size="xs" />
      </button>
    }
    <h4>Pointee AI Agent</h4>
    <button class="btn btn-icon-only right" (click)="closeChatPanel()" [tooltip]="'Close chat'" tabindex="-1">
      <svg-icon key="close" size="xs" />
    </button>
  </div>

  <!-- CHAT CONTENT -->
  <div class="chat-content p-16">
    @if (state === ChatState.Loading) {
      <p class="loading">Loading chat...</p>
    }

    @if (state === ChatState.Error) {
      <div class="error-container flex-col justify-content--center">
        <div class="error-content">
          <svg-icon key="error-circle" size="lg" class="error-icon" />
          <div class="error-text">
            <h4 class="p-b-12">Unable to connect to chat</h4>
            <p>We're having trouble connecting to the chat service. Please check your connection and try again.</p>
          </div>
        </div>
        <button class="btn btn-primitive center" (click)="retryConnection()">Try again</button>
      </div>
    }

    @if (state === ChatState.Ready) {
      <div class="messages-container" #messagesContainer>
        @for (message of messages; track $index) {
          <p class="message {{ message.role }}" [innerHTML]="message.text"></p>
        }
      </div>
    }
  </div>

  @if (state === ChatState.Ready) {
    <div class="chat-footer">
      @if (showLoadingTodos) {
        <div class="loading-info todo">
          <div class="todos-list">
            @for (todo of todos; track $index) {
              <div class="todo-item">
                @if (todo.status === 'done') {
                  <svg-icon key="done-circle" size="sm" class="todo-icon done" />
                }
                @if (todo.status === 'in_progress') {
                  <svg-icon key="navigation-right-circle-1" size="sm" class="todo-icon in-progress" />
                }
                @if (todo.status === 'pending') {
                  <svg-icon key="subtract-circle" size="sm" class="todo-icon pending" />
                }
                <span class="todo-content">{{ todo.content }}</span>
              </div>
            }
          </div>
        </div>
      }
      @if (showLoadingInfo) {
        <div class="loading-info">
          <div class="spinner-border"></div>
          <div class="labels">
            <label class="stage">{{ stage }}</label>
            <label class="message">{{ info }}</label>
          </div>
        </div>
      }

      @if (showContextInfo) {
        <div class="context-info">
          <label class="header">Context:</label>
          @if (contextProcessLabel) {
            <label class="process"><b>Process:</b> {{ contextProcessLabel }}</label>
          }
          @if (contextQueueLabel) {
            <label class="queue"><b>Queue:</b> {{ contextQueueLabel }}</label>
          }
        </div>
      }
      <div class="toolbar" [class.disabled]="toolbarDisabled">
        <div class="message-input-container">
          <textarea
            #chatInputArea
            name="chatInputArea"
            class="message form-control"
            rows="3"
            [disabled]="sendingMessage || currentQuestion !== null"
            [(ngModel)]="currentMessage"
            placeholder="Ask anything about your processes..."
            (keydown)="onKeyDown($event)"
          ></textarea>
          <button class="btn btn-send" [disabled]="sendingMessage || currentQuestion !== null || !currentMessage.trim()" (click)="sendMessage()">
            <svg-icon key="arrow-up" size="sm" />
          </button>
        </div>
      </div>

      @if (examples.length > 0) {
        <div class="examples">
          @for (example of examples; track example) {
            <button class="btn btn-secondary" [disabled]="sendingMessage || currentQuestion !== null" (click)="sendExampleMessage(example)">
              {{ example }}
            </button>
          }
        </div>
      }
    </div>
  }
</div>
